import { render, staticRenderFns } from "./RawDocumentTab.vue?vue&type=template&id=2b0098ab&scoped=true"
import script from "./RawDocumentTab.component.js?vue&type=script&lang=js&external"
export * from "./RawDocumentTab.component.js?vue&type=script&lang=js&external"
import style0 from "./RawDocumentTab.vue?vue&type=style&index=0&id=2b0098ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0098ab",
  null
  
)

export default component.exports